import { useState } from "react";
import LoginComponent from "../../components/LoginComponent/LoginComponent";
import InputField from "../../components/ui/InputField/InputField";
import { useAuth } from "../../context/AuthContext";
import CommonButton from "../../components/ui/CommonButton/CommonButton";

const Login = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const isFormValid = email && password;

  const handleLogin = async (e) => {
    if (e) e.preventDefault(); // prevent page refresh
    setLoading(true);
    setError("");
    try {
      await login({ email, password });
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoginComponent login={true}>
      <form onSubmit={handleLogin}>
        <InputField
          labelText="Email address"
          placeholder="Enter your email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <InputField
          labelText="Password"
          placeholder="Enter password"
          showEye={true}
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <CommonButton
          title={loading ? "Logging in..." : "Log in"}
          onClick={handleLogin}
          disable={!isFormValid || loading}
          loading={loading}
          type="submit" // ensures Enter key triggers submit
        />

        {error && (
          <div style={{ color: "red", marginTop: "10px" }}>{error}</div>
        )}
      </form>
    </LoginComponent>
  );
};

export default Login;